import { Button, useQueryParams } from '@insurancemenu/imenu-components-lib';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { useRootStore } from 'store/rootStore';
import ProductClassesTable from '../ProductClassesTable';
import { createStyles } from './styles';

const ProductClassesContent = observer((): JSX.Element => {
  const classes = createStyles();
  const history = useHistory();
  const { periodId } = useParams<{ periodId: string }>();
  const query = useQueryParams();
  const groupId = query.get('groupId') || '';

  const {
    eeClassesStore: { loading, saveProductClasses },
  } = useRootStore();

  const saveProductsForClasses = async (): Promise<void> => {
    await saveProductClasses(groupId, periodId);
    history.push(`/employee-elections/${periodId}?groupId=${groupId}`);
  };

  return (
    <div className={classes.eeClassContentWrapper}>
      <h2 className={classes.createClassTitle}>Set Product Eligibility</h2>
      <p className={classes.createClassSubtitle}>
        We&apos;ve loaded the confirmed plans. To exclude any employee class, you&apos;ll need to UNCHECK the product
        next to that class.
      </p>
      <ProductClassesTable />
      <div className={classes.buttonsWrapper}>
        <Button
          type="outlined"
          size="large"
          disabled={loading}
          onClick={(): void => {
            history.goBack();
          }}
        >
          Back
        </Button>
        <Button color="primary" size="large" disabled={loading} onClick={saveProductsForClasses}>
          Save Classes
        </Button>
      </div>
    </div>
  );
});

export default ProductClassesContent;
